<template lang='pug'>
v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon settings
            h4.title
              | {{ $t("webChannel.generalSettings.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              //- .md-layout
              //-   .md-layout-item(style='margin: auto;')
              //-     | {{
              //-     | $t(
              //-     | "webChannel.generalSettings.subitems.enableChannel"
              //-     | )
              //-     | }}
              //-   .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
              //-   'text-success': canalWebData.isChannelActive,\
              //-   'text-danger': !canalWebData.isChannelActive\
              //-   }")
              //-     | {{
              //-     | canalWebData.isChannelActive
              //-     | ? $t("commonWords.enabled")
              //-     | : $t("commonWords.disabled")
              //-     | }}
              //-   .md-layout-item.md-size-15
              //-     md-switch(v-model='canalWebData.isChannelActive')
              //- .md-layout
              //-   .md-layout-item(style='margin: auto;')
              //-     | {{
              //-     | $t(
              //-     | "webChannel.generalSettings.subitems.enableMicrophone"
              //-     | )
              //-     | }}
              //-   .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
              //-   'text-success': canalWebData.isSpeechToTextActive,\
              //-   'text-danger': !canalWebData.isSpeechToTextActive\
              //-   }")
              //-     | {{
              //-     | canalWebData.isSpeechToTextActive
              //-     | ? $t("commonWords.enabled")
              //-     | : $t("commonWords.disabled")
              //-     | }}
              //-   .md-layout-item.md-size-15
              //-     md-switch(v-model='canalWebData.isSpeechToTextActive')
              //- .md-layout
              //-   .md-layout-item(style='margin: auto;')
              //-     | {{
              //-     | $t(
              //-     | "webChannel.generalSettings.subitems.enableTextSpeech"
              //-     | )
              //-     | }}
              //-   .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
              //-   'text-success': canalWebData.isTextToSpeechActive,\
              //-   'text-danger': !canalWebData.isTextToSpeechActive\
              //-   }")
              //-     | {{
              //-     | canalWebData.isTextToSpeechActive
              //-     | ? $t("commonWords.enabled")
              //-     | : $t("commonWords.disabled")
              //-     | }}
              //-   .md-layout-item.md-size-15
              //-     md-switch(v-model='canalWebData.isTextToSpeechActive')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.generalSettings.subitems.enableCaptchaVerification"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success':\
                canalWebData.isCaptchaActive,\
                'text-danger': !canalWebData.isCaptchaActive\
                }")
                  | {{
                  | canalWebData.isCaptchaActive
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isCaptchaActive')
              //- .md-layout
              //-   .md-layout-item(style='margin: auto;')
              //-     | {{
              //-     | $t(
              //-     | "webChannel.generalSettings.subitems.enableOpenedChat"
              //-     | )
              //-     | }}
              //-   .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
              //-   'text-success':\
              //-   canalWebData.isChatRenderOpen,\
              //-   'text-danger': !canalWebData.isChatRenderOpen\
              //-   }")
              //-     | {{
              //-     | canalWebData.isChatRenderOpen
              //-     | ? $t("commonWords.enabled")
              //-     | : $t("commonWords.disabled")
              //-     | }}
              //-   .md-layout-item.md-size-15
              //-     md-switch(v-model='canalWebData.isChatRenderOpen')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.generalSettings.subitems.enableInteractionRating"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success':\
                canalWebData.isInteractionRatingActive,\
                'text-danger': !canalWebData.isInteractionRatingActive\
                }")
                  | {{
                  | canalWebData.isInteractionRatingActive
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isInteractionRatingActive')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.generalSettings.subitems.enableHighContrastMode"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success':\
                canalWebData.isEnableHighContrastMode,\
                'text-danger': !canalWebData.isEnableHighContrastMode\
                }")
                  | {{
                  | canalWebData.isEnableHighContrastMode
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isEnableHighContrastMode')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.generalSettings.subitems.enablePrintChat"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success':\
                canalWebData.isEnablePrintChat,\
                'text-danger': !canalWebData.isEnablePrintChat\
                }")
                  | {{
                  | canalWebData.isEnablePrintChat
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isEnablePrintChat')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.generalSettings.subitems.expirationSendMailStatus"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success':\
                canalWebData.expirationSendMailStatus,\
                'text-danger': !canalWebData.expirationSendMailStatus\
                }")
                  | {{
                  | canalWebData.expirationSendMailStatus
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.expirationSendMailStatus')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.generalSettings.subitems.enableFileUploadViaStreaming"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success':\
                canalWebData.isEnableStreamingFiles,\
                'text-danger': !canalWebData.isEnableStreamingFiles\
                }")
                  | {{
                  | canalWebData.isEnableStreamingFiles
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isEnableStreamingFiles')
</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      enabled: true,
      stt: false,
      tts: false,
      captcha: false,
      openedChat: true, // (Apresentar o Chat Aberto ou não)
      // Mocados
      chatTimeoutMs: 30000, // (Informação Mocada para o INSS) - Time do socket, exemplo caiu a internet e o usuario não voltar nesse tempo o chat encerra
      initForm: false // (Formulario de preenchimento)
    }
  }
}
</script>

<style></style>
